import React from 'react';

interface SectionLabelProps {
  text: string;
}

export const SectionLabel: React.FC<SectionLabelProps> = ({ text }) => {
  return (
    <div className="flex items-center gap-3 mb-6">
      <div className="h-px w-8 bg-emerald"></div>
      <span className="font-mono text-xs text-emerald tracking-widest uppercase">
        {text}
      </span>
    </div>
  );
};